// removed by extract-text-webpack-plugin
module.exports = {"ScreenXSMax":"(max-width: 767px)","modalContentWrapper":"Gc05dd0","modalContentSubTitle":"G99dd71","modalContentRecipes":"Gdf9363","button":"G5208f6"};